// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"5819a5ec","453":"8e9e3179","604":"cbd14291"}[chunkId] + ".chunk.js";
};